/**
 * Handle WP a11y (DO NOT REMOVE)
 *
 */
const newWp = typeof wp !== 'undefined' ? wp : {};

newWp.a11y = {
	speak() {},
};

wp = newWp;
